import * as React from 'react';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import ShoppingBagOutlinedIcon from "@mui/icons-material/ShoppingBagOutlined";
import {AppBar, Badge} from "@mui/material";
import {Trans} from 'react-i18next';
import {Link, useLocation} from "react-router";
import LanguageSelector from "./LanguageSelector";
import UserNavItem from "../../user/userNavItem/UserNavItem";
import CartManager, {useCartChange} from "../../managers/cartManager/cartManager";
import Drawer, {drawerClasses} from "@mui/material/Drawer";
import Stack from "@mui/material/Stack";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import HomeIcon from '@mui/icons-material/Home';
import StoreIcon from '@mui/icons-material/Store';
import OndemandVideoIcon from '@mui/icons-material/OndemandVideo';
import CallIcon from '@mui/icons-material/Call';
import List from "@mui/material/List";

const pages = ['Home', 'Products', 'Tutorials', 'Contact'];
const links = {
    'Home': '/',
    'Products': '/products',
    'Tutorials': '/tutorials',
    'Contact': '/contact'
};

const icons = {
    'Home': <HomeIcon/>,
    'Products': <StoreIcon/>,
    'Tutorials': <OndemandVideoIcon/>,
    'Contact': <CallIcon/>
};

const hideHeaderForPaths = ['/sign-in', '/sign-up'];

function Header() {
    const [anchorElNav, setAnchorElNav] = React.useState(null);
    const { pathname } = useLocation();
    const cart = useCartChange();

    const handleOpenNavMenu = (event) => {
        setAnchorElNav(event.currentTarget);
    };

    const handleCloseNavMenu = () => {
        setAnchorElNav(null);
    };

    const showHeader = () => {
        return hideHeaderForPaths.indexOf(pathname) === -1;
    };

    return (
        <AppBar position="fixed" color="transparent" elevation={0} sx={{backgroundColor: 'white'}}>
            {showHeader() ? <Container maxWidth="lg">
                <Toolbar disableGutters>
                    <Link to="/">
                        <Box
                            component="img"
                            sx={{
                                display: 'flex',
                                width: {xs: 150, md: 200},
                                pt: 1
                            }}
                            alt="Diwi.ro"
                            src="/diwilogo.svg"
                        />

                    </Link>
                    <Box sx={{
                        flexGrow: 1,
                        display: {xs: 'none', md: 'flex'},
                        height: '100%',
                        width: '100%',
                        justifyContent: 'end'
                    }}>
                        {pages.map((page) => (
                            <Link key={page} to={links[page]}
                                  style={{textDecoration: 'none', color: 'inherit', display: 'flex'}}>
                                <Button
                                    key={page}
                                    onClick={handleCloseNavMenu}
                                    sx={{my: 2, color: 'black', display: 'block'}}
                                >
                                    <Trans i18nKey={`header.${page}`}/>
                                </Button>
                            </Link>

                        ))}
                        <LanguageSelector/>
                        <UserNavItem/>
                        <Link key={"cart"} to="/cart"
                              style={{textDecoration: 'none', color: 'inherit', display: 'flex'}}>
                            <IconButton sx={{my: 2, color: 'black', display: 'block'}}>
                                <Badge badgeContent={CartManager.getTotalNumberOfItems(cart)} color="secondary"
                                       sx={{mt: '-6px'}}>
                                    <ShoppingBagOutlinedIcon fontSize={"small"}/>
                                </Badge>
                            </IconButton>
                        </Link>
                    </Box>

                    <Box sx={{
                        flexGrow: 1,
                        display: {xs: 'flex', md: 'none'},
                        width: '100%',
                        alignItems: 'center',
                        justifyContent: 'end'
                    }}>
                        <LanguageSelector/>
                        <UserNavItem/>
                        <IconButton size="large" color="inherit">
                            <Link to="/cart" style={{textDecoration: 'none', color: 'inherit'}}>
                                <Badge badgeContent={CartManager.getTotalNumberOfItems(cart)} color="secondary"
                                       sx={{mt: '-6px'}}>
                                    <ShoppingBagOutlinedIcon fontSize={"small"}/>
                                </Badge>
                            </Link>
                        </IconButton>
                        <IconButton
                            size="large"
                            aria-label="account of current user"
                            aria-controls="menu-appbar"
                            aria-haspopup="true"
                            onClick={handleOpenNavMenu}
                            color="inherit"
                        >
                            <MenuIcon/>
                        </IconButton>
                        <Drawer
                            id="menu-appbar"
                            anchor="right"
                            keepMounted
                            open={Boolean(anchorElNav)}
                            onClose={handleCloseNavMenu}
                            sx={{
                                display: {xs: 'block', md: 'none'},
                                minWidth: '40%',
                                zIndex: (theme) => theme.zIndex.drawer + 1,
                                [`& .${drawerClasses.paper}`]: {
                                    minWidth: '200px',
                                    backgroundImage: 'none',
                                    backgroundColor: 'background.paper',
                                }
                            }}
                        >
                            <Stack direction="row" sx={{p: 1, pb: 1, gap: 1}}>
                                <Stack
                                    direction="row"
                                    sx={{gap: 1, alignItems: 'center', flexGrow: 1, p: 1}}
                                >

                                    <Typography component="p" variant="h6">
                                        <Trans i18nKey={`header.menu`}/>
                                    </Typography>
                                </Stack>
                            </Stack>
                            <Divider/>
                            <Stack sx={{flexGrow: 1, p: 1, justifyContent: 'space-between'}}>
                                <List dense>
                                    {pages.map((page) => (
                                        <Link to={links[page]} key={page}
                                              style={{textDecoration: 'none', color: 'inherit'}}>
                                            <ListItem key={page} disablePadding sx={{display: 'block'}}
                                                      onClick={handleCloseNavMenu}>
                                                <ListItemButton>
                                                    <ListItemIcon>{icons[page]}</ListItemIcon>
                                                    <ListItemText primary={<Trans i18nKey={`header.${page}`}/>}/>
                                                </ListItemButton>
                                            </ListItem>
                                        </Link>
                                    ))}
                                </List>
                            </Stack>
                        </Drawer>
                    </Box>
                </Toolbar>

                {/*<Typography variant="h6" component="div" color="error" fontSize={24} mb={2} textAlign="center">*/}
                {/*    🚧 UNDER CONSTRUCTION 🚧*/}
                {/*</Typography>*/}
            </Container> : ''}
        </AppBar>
    );
}

export default Header;
